export default __webpack_public_path__ + "static/c3-vakantie-22-d017b82fd52e58f583126ffd8162d175.jpg";